module.exports = __webpack_public_path__ + "img/0Q3B9422-41_H_Foamcore_MockedUp.72b83dd8.jpg";